import { useRouter } from 'next/router';
import { DEFAULT_APP_LOCALE } from '@/lib/constants';

const localeRTLList = ['ar', 'he'];

/** Layout alignment helpers; RTL only applies for Arabic/Hebrew locales. */
export function useIsRTL() {
  const { locale } = useRouter();
  const resolved = locale ?? DEFAULT_APP_LOCALE;
  if (localeRTLList.includes(resolved)) {
    return { isRTL: true, alignLeft: 'right', alignRight: 'left' };
  }
  return { isRTL: false, alignLeft: 'left', alignRight: 'right' };
}
